import ToursBookingsScreen from '../(tabs)/tours/bookings'
import { seedToursBookings } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewBookingsRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursBookings} seedKey="bookings">
      <ToursBookingsScreen />
    </PreviewSeedBoundary>
  )
}
